import e from"styled-components";const o=e.div`
	position: absolute;
	inset: 0 0 0 auto;
	height: 40px;
	display: none;
	align-items: center;
	cursor: pointer;
	border-radius: 8px;
	padding: 0 3px;
	background: ${({theme:e})=>e.bg.primary};
`,t=e.div`
	position: relative;
	margin-top: 8px;

	&:hover ${o} {
		display: flex;
	}
`,i=e.div`
	position: relative;

	input {
		padding: 4px 8px 4px 30px;

		&::placeholder {
			color: ${({theme:e,isLink:o})=>o?e.text.brand:e.border.black50};
		}
	}

	& > span {
		position: absolute;
		left: 4px;
		top: 8px;
		color: ${({theme:e})=>e.text.input};
	}
`,r=e.input`
	padding: 4px 8px;
	height: 40px;
	background-color: ${({theme:e})=>e.bg.primary};
	border-radius: 8px;
	box-sizing: border-box;
	border: none;
	width: 100%;

	&:focus {
		outline: ${({theme:e})=>`2px solid ${e.text.brand}4d`};
		outline-offset: 1px;
		background-color: ${({theme:e})=>e.bg.general};
	}
`,n=e.div`
	display: flex;
	flex-direction: column;
	row-gap: 16px;
`,p=e.div`
	display: grid;
	grid-template-columns: 3fr 1.5fr;
	column-gap: 10px;
	align-items: center;
	border-radius: 3px;
	padding: 6px 0;
	background-color: ${({isSelected:e})=>e?"rgba(7, 20, 90, 0.1)":"transparent"};

	cursor: ${({isClickable:e})=>e?"pointer":"default"};

	&:hover {
		background-color: ${({isClickable:e})=>e?"rgba(7, 20, 90, 0.05)":"transparent"};
	}

	&:active {
		background-color: ${({isClickable:e})=>e?"rgba(7, 20, 90, 0.1)":"transparent"};
	}
`,l=e.div`
	display: flex;
	flex-direction: column;
	padding: 10px 0px 0px 0px;
`,a=e.div`
	color: ${({theme:e})=>e.text.text};
	font-weight: 500;
	font-size: 13px;
	line-height: 16px;
	opacity: 0.5;
`,d=e.span`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 14px;
`,s=e(d)`
	color: ${({theme:e})=>e.text.link};
	font-weight: 400;
	line-height: 16px;
	user-select: none;
`,x=e(d)`
	color: ${({theme:e})=>e.text.title};
	user-select: none;
`;export{o as CloseButton,t as Container,a as HeaderLabels,r as Input,p as ListItem,l as ListItemsContainer,x as ListSpace,s as ListTitle,n as SearchSelectContainer,i as TextContainer};
